import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withFirebase } from '../../firebase';
import Switch from "react-switch";
import { faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import uuid from 'react-uuid'
import Loader from 'react-loader-spinner';
import ModalConfirmCustom from '../../useful/ModalConfirmCustom';

const LeagueForm = (props) => {

    const userId = props.firebase.auth.currentUser.uid; // user auth uid
    const { tournament, teams, showModal } = props;
    const [checked, setChecked] = useState(false);
    const [loading, setloading] = useState(false);

    const [confirmShow, setConfirmShow] = useState(false);

    if (teams.length < 2) {
        return (
            <div className="row nav justify-content-center small pt-2">
                <span className="col-12 col-md-9 text-secondary font-italic text-center font-italic">
                    La cantidad de equipos no es suficiente.
                </span>
            </div>
        )
    }

    const onSubmit = () => {
        setConfirmShow(true);
    }

    const generateMatches = () => {
        setConfirmShow(false);
        //check amount of teams > 1
        let teamsCopy = Object.assign([], teams);
        if (teamsCopy && teamsCopy.length > 1) {

            setloading(true);
            if (teamsCopy.length % 2 != 0) { // add empty team for uneven teams
                teamsCopy.push(null);
            }
            //generate matches...
            try {
                const batch = props.firebase.batch();

                const matchdayTitle = "Jornada ";
                let matchday = 0;
                let n = teamsCopy.length;
                let k = n - 1;
                while (k--) {
                    matchday++;
                    let i, j;
                    for (i = 0, j = n - 1; i < j; i++, j--) {

                        let teamA = teamsCopy[i];
                        let teamB = teamsCopy[j];
                        if (k % 2 === 0) {
                            teamA = teamsCopy[j];
                            teamB = teamsCopy[i];
                        }

                        if (teamA && teamB) {
                            const match = {
                                userUid: userId,
                                tournamentUid: tournament.uid,
                                teamA: teamA.uid,
                                teamB: teamB.uid,
                                matchday: {
                                    index: matchday,
                                    title: matchdayTitle + matchday
                                }
                            };
                            batch.set(props.firebase.matchDoc(userId, tournament.uid, uuid()), match);
                            if (checked) {
                                const match1 = {
                                    userUid: userId,
                                    tournamentUid: tournament.uid,
                                    teamA: teamB.uid,
                                    teamB: teamA.uid,
                                    matchday: {
                                        index: matchday + n - 1,
                                        title: matchdayTitle + (matchday + n - 1)
                                    }
                                };
                                batch.set(props.firebase.matchDoc(userId, tournament.uid, uuid()), match1);
                            }
                        }
                    }

                    // rotate keeping firt team 
                    const first = teamsCopy.shift();
                    const temp = teamsCopy.shift();

                    teamsCopy.push(temp)
                    teamsCopy.unshift(first);
                }

                // insert subtype (ida/vuelta)
                let _subType = "Ida";
                if (checked) {
                    _subType = "Ida/Vuelta";
                }

                // set matchesGenerated to tournament item...
                batch.update(props.firebase.tournamentDoc(userId, tournament.uid), { matchesGenerated: true, subType: _subType });

                batch.commit().then(() => {
                    setloading(false);
                }).catch(error => {
                    setloading(false);
                    console.log("Error: ", error);
                    showModal("Error", "Ocurrió un error al generar los partidos. Compruebe los datos e intentelo de nuevo.")
                });
            } catch (error) {
                setloading(false);
                console.log("Error: ", error);
                showModal("Error", "Ocurrió un error al generar los partidos. Compruebe los datos e intentelo de nuevo.")
            }

        } else {
            showModal("Información", "Es necesario tener como mínimo 2 equipos.");
        }

    }

    return (
        <div className="col small" >

            <div className="row nav justify-content-center">
                <span className="col-12 col-md-9 text-secondary font-italic text-center font-italic">
                    Marque si desea generar partidos de ida y vuelta. Una ves generado los partidos, los cambios los debrá realizar de forma manual.
                </span>
            </div>


            {!(loading) ?
                <div className="row mt-2">
                    <div className="col-12 nav justify-content-center">
                        <label htmlFor="switch">
                            <span className="mr-1">Ida y vuelta</span>
                            <Switch
                                onChange={(checked) => setChecked(checked)}
                                checked={checked}
                                uncheckedIcon={<p className="small text-white font-weight-bold text-center pt-1">No</p>}
                                checkedIcon={<p className="small text-white font-weight-bold text-center pt-1">Si</p>}
                                onColor="#28a745"
                                offColor="#90a4ae"
                                handleDiameter={16}
                                height={22}
                                width={44}
                                id="switch"
                            />
                        </label>
                    </div>


                    <div className="col-12 nav justify-content-center">
                        <button onClick={onSubmit} className="col-auto btn btn-sm btn-success m-1">
                            <FontAwesomeIcon className="mr-2" icon={faCheck} />
                            <span>Generar Partidos</span>
                        </button>
                    </div>


                </div>
                :
                <div className="col-12 nav justify-content-center">
                    <Loader className="m-2"
                        type="ThreeDots"
                        color="#263238"
                        height={30}
                        width={60}
                        timeout={0} />
                </div>
            }

            {/* LeagueConfirm Modal */}
            <ModalConfirmCustom
                show={confirmShow}
                onClose={() => setConfirmShow(false)}
                onConfirm={generateMatches}
            >
                <p className="card-title font-weight-bolder">Generar Partidos</p>

                <div className="text-black-50 font-italic small mb-3">
                    <FontAwesomeIcon className="text-break mr-1" icon={faExclamationTriangle} />
                    <span>El campo <strong>"Ida y vuelta"</strong> no podrá ser modificado mas adelante.</span>
                </div>

                <p className="small card-text text-break">Está seguro que desea generar los partidos?</p>

            </ModalConfirmCustom>

        </div>
    );
}

export default withFirebase(LeagueForm);